import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import nodata from "../../Img/no-data.svg";
import { useTheme, useMediaQuery, Button } from "@mui/material";
import { useState } from "react";
import consts from '../../constant';
import usercalls from "../../Axios";
import { useLocation, useParams } from 'react-router-dom';
import { useEffect, useContext } from 'react';
import io from "socket.io-client";
import Context from '../../Context'
import { toast } from 'react-toastify';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Capitalize } from "../../Helpers/StringFunctions";
import { getTimeFormat } from '../../Helpers/DateAndTime';


export default function Currentorders() {
  const theme = useTheme();
  const mobilemd = useMediaQuery(theme.breakpoints.up("md"));

  const scrollRef = React.useRef(null);

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  function truncateToDecimals(num, decimals = 12) {
    const factor = Math.pow(10, decimals);
    return Math.floor(num * factor) / factor;
  }


  const loaction = useLocation();
  const placeRoute = loaction.pathname?.split('/')[1];

  const tableData1 = [
    {
      spotPairs: "BTC/USDT",
      orderType: "Limit",
      direction: "Buy",
      orderValue: "$5000",
      orderQty: "0.1 BTC",
      orderPrice: "$50,000",
      triggerPrice: "$49,500",
      orderStatus: "Pending",
      orderTime: "2025-01-20 14:30",
      orderId: "12345",
      action: "Cancel",
    },
    {
      spotPairs: "ETH/USDT",
      orderType: "Market",
      direction: "Sell",
      orderValue: "$2000",
      orderQty: "1 ETH",
      orderPrice: "$2,000",
      triggerPrice: "N/A",
      orderStatus: "Completed",
      orderTime: "2025-01-20 14:45",
      orderId: "12346",
      action: "Completed",
    },
  ];


  const tableData2 = [
    {
      spotPairs: "BTC/USDT",
      orderType: "Limit",
      direction: "Buy",
      orderValue: "$5000",
      orderQty: "0.1 BTC",
      orderPrice: "$50,000",
      triggerPrice: "$49,500",
      orderStatus: "Pending",
      orderTime: "2025-01-20 14:30",
      orderId: "12345",
      action: "Cancel",
    },
    {
      spotPairs: "ETH/USDT",
      orderType: "Market",
      direction: "Sell",
      orderValue: "$2000",
      orderQty: "1 ETH",
      orderPrice: "$2,000",
      triggerPrice: "N/A",
      orderStatus: "Completed",
      orderTime: "2025-01-20 14:45",
      orderId: "12346",
      action: "Completed",
    },
  ];

  const tableData3 = [
    {
      spotPairs: "BTC/USDT",
      orderType: "Limit",
      direction: "Buy",
      orderValue: "$5000",
      orderQty: "0.1 BTC",
      orderPrice: "$50,000",
      triggerPrice: "$49,500",
      orderStatus: "Pending",
      orderTime: "2025-01-20 14:30",
      orderId: "12345",
      action: "Cancel",
    },
    {
      spotPairs: "ETH/USDT",
      orderType: "Market",
      direction: "Sell",
      orderValue: "$2000",
      orderQty: "1 ETH",
      orderPrice: "$2,000",
      triggerPrice: "N/A",
      orderStatus: "Completed",
      orderTime: "2025-01-20 14:45",
      orderId: "12346",
      action: "Completed",
    },
  ];


  const { currentOrderData, setBalanceUpdate } = useContext(Context)

  const [current_activeTab, setcurrent_ActiveTab] = useState("current-limit-market");

  const path = usercalls();

  // const [orderHistory, setOrderHistory] = useState([])

  // const openOrderSocket = async () => {
  //   try {
  //     setOrderHistory([])
  //     // const socket = io(`${consts?.socketUrl}`, { path: "/socket" }); // for Live
  //     const socket = io(`${consts?.socketUrl}`);  // for local

  //     socket.on('connect', () => {

  //       const request = {
  //         userId: localStorage.getItem('use'),
  //         type: placeRoute
  //       };
  //       socket.emit('getOpenOrders', request);
  //     });


  //     socket.on('getOpenOrders', (data) => {

  //       if (data?.success) {
  //         setOrderHistory(data?.data);
  //         // setOrderCount(data?.data?.length);
  //         setOpenOrders(data?.data?.length)
  //       } else {
  //         console.log('Error:', data?.message);
  //       }
  //     });


  //     socket.on('disconnect', () => {
  //       console.log('Disconnected from backend WebSocket');
  //     });

  //   } catch (error) {
  //     console.log("🚀 ~ getOpenOrdersSocket ~ error:", error);
  //   }
  // };

  // useEffect(() => {
  //   if (localStorage.getItem('use')) {
  //     openOrderSocket();
  //   }
  // }, []);

  const [cancelLoading, setCancelLoading] = useState(false)

  const cancelOrder = async (orderId) => {
    try {
      var url
      var payload
      if (placeRoute == "future") {
        url = `${consts?.BackendUrl}/kucoin/kucoinFutureCancelTrade`
        payload = {
          tradeId: orderId?._id
        }
      } else {
        url = `${consts?.BackendUrl}/kucoin/cancelOrder`
        payload = {
          tradeId: orderId?._id
        }
      }
      // console.log(url, payload, "paylaod")
      setCancelLoading(true)
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success == true) {
        toast.success(result?.message || "Order Cancelled Successfully")
        setBalanceUpdate(Math.random(6))
      } else {
        toast.error(result?.message)
      }
      setCancelLoading(false)
    } catch (error) {
      setCancelLoading(false)
      console.log("🚀 ~ cancelOrder ~ error:", error)
    }
  }


  return (
    <>
      <div className='history_inner_tab' >
        <div className='h_tabs'>
          <button
            className={`history_button ${current_activeTab === "current-limit-market" ? "active" : ""}`}
            onClick={() => setcurrent_ActiveTab("current-limit-market")}
          >
            Limit & Market Orders
          </button>
          {/* <button
            className={`history_button ${current_activeTab === "current TP/SL Order" ? "active" : ""}`}
            onClick={() => setcurrent_ActiveTab("current TP/SL Order")}
          >
            TP/SL Order
          </button>
          <button
            className={`history_button ${current_activeTab === "current Conditional Order" ? "active" : ""}`}
            onClick={() => setcurrent_ActiveTab("current Conditional Order")}
          >
            Conditional Order
          </button>
          <button
            className={`history_button ${current_activeTab === "current OCO" ? "active" : ""}`}
            onClick={() => setcurrent_ActiveTab("current OCO")}
          >
            OCO
          </button> */}
          <ChevronRightIcon sx={{ display: !mobilemd ? 'block' : 'none' }} className="scroll-btn" onClick={scrollRight} />
        </div>
        {current_activeTab === "current-limit-market" &&
          <div className='table_height' >
            <TableContainer className='history_table' >
              <Table>
                <TableHead>
                  {
                    placeRoute == "future" ?
                      <TableRow>
                        <TableCell>Contract</TableCell>
                        <TableCell className="fixed-left">Type</TableCell>
                        <TableCell>Order Price</TableCell>
                        <TableCell>Amount</TableCell>
                        {/* <TableCell>Order Price</TableCell>
                        <TableCell>StopLimit Price</TableCell> */}
                        {/* <TableCell>Filled/Order Quantity</TableCell> */}
                        <TableCell>Order Value</TableCell>
                        <TableCell>Time</TableCell>
                        <TableCell>Order ID</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell className="fixed-right">Action</TableCell>
                      </TableRow>
                      :
                      <TableRow>
                        <TableCell align="center">Order Time</TableCell>
                        <TableCell align="center" className="fixed-left">Pairs</TableCell>
                        <TableCell align="center">Order Type</TableCell>
                        <TableCell align="center">Side</TableCell>
                        {/* <TableCell>Order Value</TableCell> */}
                        <TableCell align="center">Order Price</TableCell>
                        <TableCell align="center">StopLimit Price</TableCell>
                        <TableCell align="center">Order Quantity</TableCell>
                        {/* <TableCell>TP/SL</TableCell> */}
                        <TableCell align="center">Order ID</TableCell>
                        <TableCell align="center">Status</TableCell>
                        <TableCell align="center" className="fixed-right">Action</TableCell>
                      </TableRow>
                  }
                </TableHead>
                <TableBody>
                  {currentOrderData?.length > 0 ? (
                    currentOrderData?.map((row, index) => (
                      <TableRow key={index}>
                        <>
                          {
                            placeRoute == "future" ?
                              <>
                                <TableCell className="fixed-left">{row?.pair}

                                  <span>{row?.marginAccount}</span>
                                  <span>{row?.leverage}X </span>
                                </TableCell>
                                <TableCell>{row?.positionSide}/{row?.order_type}</TableCell>
                                <TableCell>{row?.price}</TableCell>
                                <TableCell>{row?.volume}</TableCell>
                                {/* <TableCell>{row?.remaining}</TableCell> */}
                                <TableCell>{truncateToDecimals(Number(row?.price) * Number(row?.volume))}</TableCell>
                                {/* <TableCell>{row?.stoplimit ? row?.stoplimit : "-"}</TableCell> */}
                                <TableCell>
                                  {getTimeFormat(row?.createdAt)}
                                  {/* {row?.createdAt?.split("T")[0]}: {row?.createdAt?.split("T")[1].split(".")[0]} */}
                                </TableCell>
                                {/* <TableCell>{row.orderValue}</TableCell> */}
                                {/* <TableCell>{row.tpSl}</TableCell> */}
                                <TableCell>{row?.order_id}</TableCell>
                                <TableCell>{row?.status ? row?.status?.toUpperCase() : 'Filled'}</TableCell>
                                <TableCell className="fixed-right">
                                  <div className="cncel">
                                    <Button disabled={cancelLoading} onClick={() => { cancelOrder(row) }} variant='contained' color='error' size='small' >Cancel</Button>
                                  </div>
                                </TableCell>
                              </>
                              :
                              <>
                                <TableCell align="center" >
                                  {getTimeFormat(row?.createdAt)}
                                  {/* {row?.createdAt?.split("T")[0]}: {row?.createdAt?.split("T")[1].split(".")[0]} */}

                                </TableCell>
                                <TableCell align="center" className="fixed-left">{row?.pair}</TableCell>
                                <TableCell align="center">{row?.order_type}</TableCell>
                                <TableCell align="center">{row?.trade_type}</TableCell>
                                {/* <TableCell>{row.orderValue}</TableCell> */}
                                <TableCell align="center">{row?.price} {row?.pair?.split("_")[1]}</TableCell>
                                <TableCell align="center">{row?.stoplimit ? row?.stoplimit : "-"} {row?.pair?.split("_")[1]}</TableCell>
                                <TableCell align="center">{row?.volume}  {row?.pair?.split("_")[0]} </TableCell>
                                {/* <TableCell>{row.tpSl}</TableCell> */}
                                <TableCell align="center">{row?.order_id}</TableCell>
                                <TableCell align="center">{row?.status ? row?.status?.toUpperCase() : 'Filled'}</TableCell>
                                <TableCell align="center" className="fixed-right">
                                  <div className="cncel">
                                    <Button disabled={cancelLoading} onClick={() => { cancelOrder(row) }} variant='contained' color='error' size='small' >Cancel</Button>
                                  </div>
                                </TableCell>
                              </>
                          }
                        </>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <img src={nodata} alt="No Data" style={{ maxWidth: "100px" }} />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>}
        {current_activeTab === "current TP/SL Order" &&
          <div className='table_height' >
            <TableContainer className='history_table' >
              <Table>
                <TableHead>
                  <TableRow className="fixed-top">
                    <TableCell className="fixed-left">Spot Pairs</TableCell>
                    <TableCell>Order Type</TableCell>
                    <TableCell>Direction</TableCell>
                    <TableCell>Order Value</TableCell>
                    <TableCell>Order Qty</TableCell>
                    <TableCell>Order Price</TableCell>
                    <TableCell>Trigger Price</TableCell>
                    <TableCell>Order Status</TableCell>
                    <TableCell>Order Time</TableCell>
                    <TableCell>Order ID</TableCell>
                    <TableCell className="fixed-right">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData1 && tableData1.length > 0 ? (
                    tableData1.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell className="fixed-left">{row.spotPairs}</TableCell>
                        <TableCell>{row.orderType}</TableCell>
                        <TableCell>{row.direction}</TableCell>
                        <TableCell>{row.orderValue}</TableCell>
                        <TableCell>{row.orderQty}</TableCell>
                        <TableCell>{row.orderPrice}</TableCell>
                        <TableCell>{row.triggerPrice}</TableCell>
                        <TableCell>{row.orderStatus}</TableCell>
                        <TableCell>{row.orderTime}</TableCell>
                        <TableCell>{row.orderId}</TableCell>
                        <TableCell className="fixed-right">{row.action}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <img src={nodata} alt="No Data" style={{ maxWidth: "100px" }} />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>}
        {current_activeTab === "current Conditional Order" &&
          <div className='table_height' >
            <TableContainer className="history_table">
              <Table>
                <TableHead>
                  <TableRow className="fixed-top">
                    <TableCell className="fixed-left">Spot Pairs</TableCell>
                    <TableCell>Order Type</TableCell>
                    <TableCell>Direction</TableCell>
                    <TableCell>Order Value</TableCell>
                    <TableCell>Order Qty</TableCell>
                    <TableCell>Order Price</TableCell>
                    <TableCell>Trigger Price</TableCell>
                    <TableCell>Order Status</TableCell>
                    <TableCell>Order Time</TableCell>
                    <TableCell>Order ID</TableCell>
                    <TableCell className="fixed-right">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData2 && tableData2.length > 0 ? (
                    tableData2.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell className="fixed-left">{row.spotPairs}</TableCell>
                        <TableCell>{row.orderType}</TableCell>
                        <TableCell>{row.direction}</TableCell>
                        <TableCell>{row.orderValue}</TableCell>
                        <TableCell>{row.orderQty}</TableCell>
                        <TableCell>{row.orderPrice}</TableCell>
                        <TableCell>{row.triggerPrice}</TableCell>
                        <TableCell>{row.orderStatus}</TableCell>
                        <TableCell>{row.orderTime}</TableCell>
                        <TableCell>{row.orderId}</TableCell>
                        <TableCell className="fixed-right">{row.action}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={11} align="center">
                        <img src={nodata} alt="No Data" style={{ maxWidth: "100px" }} />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>}
        {current_activeTab === "current OCO" &&
          <div className='table_height' >
            <TableContainer className="history_table">
              <Table>
                <TableHead>
                  <TableRow className="fixed-top">
                    <TableCell className="fixed-left">Spot Pairs</TableCell>
                    <TableCell>Order Type</TableCell>
                    <TableCell>Direction</TableCell>
                    <TableCell>Order Value</TableCell>
                    <TableCell>Order Qty</TableCell>
                    <TableCell>TP/SL Order Price</TableCell>
                    <TableCell>TP/SL Trigger Price</TableCell>
                    <TableCell>Order Status</TableCell>
                    <TableCell>Order Time</TableCell>
                    <TableCell>Order ID</TableCell>
                    <TableCell className="fixed-right">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData3 && tableData3.length > 0 ? (
                    tableData3.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell className="fixed-left">{row.spotPairs}</TableCell>
                        <TableCell>{row.orderType}</TableCell>
                        <TableCell>{row.direction}</TableCell>
                        <TableCell>{row.orderValue}</TableCell>
                        <TableCell>{row.orderQty}</TableCell>
                        <TableCell>{row.orderPrice}</TableCell>
                        <TableCell>{row.triggerPrice}</TableCell>
                        <TableCell>{row.orderStatus}</TableCell>
                        <TableCell>{row.orderTime}</TableCell>
                        <TableCell>{row.orderId}</TableCell>
                        <TableCell className="fixed-right">{row.action}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={11} align="center">
                        <img src={nodata} alt="No Data" style={{ maxWidth: "100px" }} />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>}
      </div>
    </>
  );
}
